export default __webpack_public_path__ + "static/media/Claw of Khan.6d78834b.jpg";